import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeadDetails, deleteLead } from "../../../../utils/redux/lead/leadActions";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LeadDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedLead } = useSelector(state => state.lead);

    useEffect(() => {
        dispatch(fetchLeadDetails(id));
    }, [id]);

    const handleDelete = async () => {
        if (!window.confirm("Delete lead?")) return;

        const res = await dispatch(deleteLead(id));
        if (res?.success) {
            toast.success("Deleted");
            navigate("/leads");
        }
    };

    if (!selectedLead) return <div className="p-4">Loading...</div>;

    const { first_name, last_name, email, phone, profile, context } = selectedLead;

    return (
        <div className="container py-4">
            <div className="card">
                <div className="card-body">

                    <div className="d-flex justify-content-between mb-3">
                        <h4>{first_name} {last_name}</h4>

                        <button className="btn btn-danger" onClick={handleDelete}>
                            Delete
                        </button>
                    </div>

                    <p><strong>Email:</strong> {email}</p>
                    <p><strong>Phone:</strong> {phone}</p>
                    <p><strong>Profile:</strong> {profile}</p>
                    <p><strong>Request Type:</strong> {context?.request_type}</p>

                    {/* METADATA */}
                    <div className="mt-3">
                        <h6>Metadata</h6>
                        <pre style={{ background: "#f5f5f5", padding: "10px" }}>
                            {JSON.stringify(context?.metadata, null, 2)}
                        </pre>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default LeadDetailsPage;